import { COMMITMENTS } from "./content";
import { useCounter } from "./hooks";

function Commit({ item, lang }) {
  const m = item.fig.match(/^(\d+)(.*)$/);
  const target = m ? parseInt(m[1], 10) : 0;
  const rest = m ? m[2] : item.fig;
  const suffix = lang === "fr" ? item.suffixFr : item.suffixEn;
  const { ref, value } = useCounter(target);

  return (
    <div className="commit reveal" data-testid="commit-card">
      <div>
        <div className="commit__fig">
          <span ref={ref}>{value}</span>
          {rest}
          {suffix && <span className="suffix">{suffix}</span>}
        </div>
      </div>
      <div>
        <div className="commit__label">{lang === "fr" ? item.labelFr : item.labelEn}</div>
        <p className="commit__body">{lang === "fr" ? item.bodyFr : item.bodyEn}</p>
      </div>
    </div>
  );
}

export default function Engagements({ lang }) {
  return (
    <section className="section" id="engagements" data-testid="section-engagements">
      <div className="container">
        <div className="commit-grid">
          {COMMITMENTS.map((c, i) => (
            <Commit key={i} item={c} lang={lang} />
          ))}
        </div>
      </div>
    </section>
  );
}
